var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jump2act"},[_c('button',{staticClass:"jump2act-btn",style:(("backgroundColor: " + _vm.btnColor)),on:{"click":_vm.eClickBtn}},[_vm._v(_vm._s(_vm.btnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }